import api from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].rules[0].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].rules[2]!./SupportLink.css";

var options = {"injectType":"singletonStyleTag","insert":"body"};

options.insert = "body";
options.singleton = true;

var update = api(content, options);



export default content.locals || {};